
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CustomerHelper } from '../../crm/helpers/customerHelper'
import { Settings } from '../../core/services/configService'
import { CrudService } from '../../core/services/crudService'
import { ParentNameCard } from '../../crm/constants'
import store from '../../core/store'
@Component
export default class VirtualCard extends Vue {
  @Prop({ default: '' }) qrImgSrc!: string

  customer: any = null
  sponsors: string[] = []
  selectedSponsors: string[] = []
  seasonPassName: string | null = null
  qrUrl: string | null = null
  currentSlide = 0
  carouselInterval: any = null
  animationId: number | null = null
  lastTs: number | null = null
  offsetX: number = 0
  speedPxPerSec: number = 40
  backgroundLoaded = false
  backgroundImg: string = 'https://rsdalcala.yocus.com/public/padel/uploads/rsdalcala/638786011933895374_Sint%C3%ADtulo-12.jpg' // mismo default que tu HTML
  shieldImg: string | null = null
  additionalFields: any[] = []
  virtualCardConfigs: any = null

  defaultAvatar =
    'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64"><rect width="100%" height="100%" fill="%23eee"/><circle cx="32" cy="24" r="12" fill="%23aaa"/><rect x="14" y="40" width="36" height="16" rx="8" fill="%23bbb"/></svg>'

  get leftFields() {
    return this.additionalFields.filter((f: any) => f.col1)
  }

  get rightFields() {
    return this.additionalFields.filter((f: any) => f.col2)
  }

  get filteredLeftFields() {
    return this.leftFields.filter((f: any) => {
      const lbl = (f.label || f.name || '').toLowerCase()
      if (lbl === 'name' || lbl === 'nombre' || lbl === 'surname' || lbl === 'apellido') return false
      const val = String(this.getFieldValue(f) ?? '').trim()
      return val.length > 0
    })
  }

  get filteredRightFields() {
    return this.rightFields.filter((f: any) => {
      const lbl = (f.label || f.name || '').toLowerCase()
      if (lbl === 'name' || lbl === 'nombre' || lbl === 'surname' || lbl === 'apellido') return false
      const val = String(this.getFieldValue(f) ?? '').trim()
      return val.length > 0
    })
  }

  get orderedFields() {
    const res: any[] = []
    const max = Math.max(this.leftFields.length, this.rightFields.length)
    for (let i = 0; i < max; i++) {
      if (this.leftFields[i]) res.push({ ...this.leftFields[i], col1: true })
      if (this.rightFields[i]) res.push({ ...this.rightFields[i], col2: true })
    }
    return res.filter((f: any) => {
      const lbl = (f.label || f.name || '').toLowerCase()
      return lbl !== 'name' && lbl !== 'nombre' && lbl !== 'surname' && lbl !== 'apellido'
    })
  }

  getFieldValue(field: any) {
    if (!this.customer) return ''
    const lower = (field.name || '').toLowerCase()
    const rootKey = Object.keys(this.customer).find((k) => k.toLowerCase() === lower)
    if (rootKey) {
      let val: any = this.customer[rootKey]
      if (lower === 'gender') {
        const n = Number(val)
        if (!isNaN(n)) {
          return n === 0 ? (this.$t && this.$t('Male')) || 'Male' : (this.$t && this.$t('Female')) || 'Female'
        }
      }
      return val ?? ''
    }
    const customFieldName = `CustomField${field.id}`.toLowerCase()
    const cf = this.customer.customFields?.find((c: any) => c.name?.toLowerCase() === customFieldName)
    return cf?.value ?? ''
  }

  get sponsorsForCarousel() {
    if (this.sponsors.length > 3) {
      return [...this.sponsors, ...this.sponsors.slice(0, 3)]
    }
    return this.sponsors
  }

  get tenantLogo() {
    if (this.shieldImg) return this.shieldImg
    const st = store.state.settings
    if (!st?.Mainlogo) return ''
    return st.Uploads + '/' + st.Mainlogo
  }

  get tenantName() {
    return store.state.settings?.Title || ''
  }

  get seasonPassTitle() {
    return this.seasonPassName || (this.$t && this.$t('Virtual Card')) || 'Virtual Card'
  }

  

  get fullName() {
    if (!this.customer) return ''
    return this.customer.fullName || [this.customer.name, this.customer.surname].filter(Boolean).join(' ')
  }

  get customerImage() {
    const c = this.customer || {}
    const uploads = store.state.settings.Uploads
    const candidates = [c.logo, c.Logo, c.photoUrl, c.PhotoUrl, c.image, c.Image, c.avatar, c.Avatar, c.picture, c.Picture, c.photo, c.Photo, c.img, c.Img]
    let val = candidates.find((x: any) => typeof x === 'string' && x.trim().length > 0)
    if (!val) return this.defaultAvatar
    val = String(val)
    if (val.startsWith('http')) return val
    if (val.startsWith('/public/')) return val
    return uploads + '/' + val.replace(/^\/+/, '')
  }

  get topImage() {
    // si hay config la usamos; si no, queda el default EXACTO del HTML
    return this.backgroundImg
  }

  get qrImage() {
    return this.qrImgSrc || this.qrUrl || ''
  }

  async mounted() {
    // Cargar config (sin tocar estilos)
    const configUrl = `${Settings.HostName}/api/CzVirtualCardConfigs/config`
    const configRes = await new CrudService().httpGet(configUrl)
    const cfg: any = configRes?.data ?? configRes
    if (cfg) {
      if (cfg.topImage) {
        this.backgroundImg = store.state.settings.Uploads + '/' + cfg.topImage
      }
      if (cfg.shield) {
        this.shieldImg = store.state.settings.Uploads + '/' + cfg.shield
      }
      if (cfg.selectedSponsors) {
        try { this.selectedSponsors = JSON.parse(cfg.selectedSponsors) } catch {}
      }
    }

    // Precarga (opcional)
    const pre = new Image()
    pre.src = this.backgroundImg
    pre.onload = () => { this.backgroundLoaded = true }

    // Configs alternativas
    const vcUrl = `${Settings.HostName}/api/CzVirtualCardConfigs/config`
    const vc = await new CrudService().httpGet(vcUrl)
    if (vc && (vc.ok || vc.status === 200)) {
      this.virtualCardConfigs = vc.data ?? vc.model ?? vc
      if (this.virtualCardConfigs.selectedSponsors) {
        try { this.selectedSponsors = JSON.parse(this.virtualCardConfigs.selectedSponsors) } catch {}
      }
    }

    // Cliente + pase + QR
    const cid = CustomerHelper.getStoredCustomer()
    if (cid !== undefined) {
      const data = await CustomerHelper.getCustomerData(cid)
      this.customer = data?.data ?? data

      const seasonUrl = `${Settings.HostName}/api/PublicCustomerPeriodicSales/customer-season-passes/${cid}`
      const seasonData = await new CrudService().httpGet(seasonUrl)
      if (seasonData && seasonData.ok && Array.isArray(seasonData.model) && seasonData.model.length) {
        const latest = seasonData.model.sort(
          (a: any, b: any) => new Date(b.start).getTime() - new Date(a.start).getTime()
        )[0]
        this.seasonPassName = latest?.product?.seasonPassName || null
      }

      try {
        const qrRes = await new CrudService().httpGet(`${Settings.HostName}/api/publicaccesscontrol/qr`)
        const qrModel = qrRes?.data?.model ?? qrRes?.model ?? qrRes
        if (qrModel) {
          const content = qrModel.content || qrModel.Content
          const contentType = qrModel.contentType || qrModel.ContentType || 'image/png'
          const encoding = qrModel.encoding || qrModel.Encoding || 'base64'
          this.qrUrl = content ? `data:${contentType};${encoding},${content}` : null
        }
      } catch {}
    }

    // Sponsors
    const url = `${Settings.HostName}/api/fileuploads/open-list?parentName=CZConfig&parentId=1&category=Sponsors`
    const data = await new CrudService().httpGet(url)
    if (data && data.ok) {
      let imgs: any[] = data.data
      if (this.selectedSponsors.length) {
        imgs = imgs.filter((img: any) => this.selectedSponsors.includes(img.url))
      }
      this.sponsors = imgs.map(
        (img: any) => store.state.settings.Uploads + '/CzConfig/Sponsors/' + img.url
      )
      this.$nextTick(() => this.startCarousel())
    }

    // Campos (col1/col2)
    const fieldsUrl = `${Settings.HostName}/api/dynamicforms/form-def/${ParentNameCard}/0`
    const fields = await new CrudService().httpGet(fieldsUrl)
    if (fields && fields.ok && Array.isArray(fields.model)) {
      this.additionalFields = fields.model.filter((f: any) => f.col1 || f.col2)
    }
  }

  startCarousel() {
    if (this.sponsors.length <= 3) return
    const track = this.$refs.track as HTMLElement
    if (!track) return
    const slide = track.firstElementChild as HTMLElement
    const slideWidth = slide ? slide.clientWidth : 0
    const loopWidth = slideWidth * this.sponsors.length

    const step = (ts: number) => {
      if (this.lastTs === null) this.lastTs = ts
      const dt = (ts - (this.lastTs || ts)) / 1000
      this.lastTs = ts
      this.offsetX += this.speedPxPerSec * dt
      if (this.offsetX >= loopWidth) {
        this.offsetX -= loopWidth
      }
      track.style.transition = 'none'
      track.style.transform = `translateX(-${this.offsetX}px)`
      this.animationId = requestAnimationFrame(step)
    }
    if (this.animationId) cancelAnimationFrame(this.animationId)
    this.offsetX = 0
    this.lastTs = null
    this.animationId = requestAnimationFrame(step)
  }

  beforeDestroy() {
    if (this.carouselInterval) clearInterval(this.carouselInterval)
    if (this.animationId) cancelAnimationFrame(this.animationId)
  }
}
